<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9611 15.1242L21.8297 13.9928L19.9954 15.8272V9.9558C19.9954 8.36797 19.4559 7.10578 18.5811 6.23938C17.7143 5.38102 16.5654 4.95851 15.4281 4.95853C14.2909 4.95855 13.142 5.38111 12.2752 6.23947C11.4004 7.10586 10.8609 8.36803 10.8609 9.9558V14.5262C10.8609 16.7599 9.47094 17.7428 8.21822 17.7583C7.56947 17.7664 6.92734 17.5216 6.44478 17.0197C5.96652 16.5224 5.59539 15.719 5.59539 14.5262V7.72565L7.43529 9.52975L8.55549 8.38731L4.73545 4.6416L1.03894 8.22028L2.15184 9.36983L3.99539 7.58504V14.5262C3.99539 16.0641 4.48246 17.2874 5.29148 18.1287C6.0962 18.9656 7.17046 19.3715 8.23809 19.3582C10.4181 19.3311 12.4609 17.5834 12.4609 14.5262V9.9558C12.4609 8.74545 12.8632 7.90901 13.4011 7.37631C13.9471 6.83557 14.6818 6.55854 15.4282 6.55853C16.1745 6.55852 16.9092 6.83551 17.4552 7.37623C17.9931 7.90891 18.3954 8.74537 18.3954 9.9558V15.8272L16.5611 13.9928L15.4297 15.1242L19.1954 18.8899L22.9611 15.1242Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
